import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import PropTypes from "prop-types";
import CommonRadioOpcoes from "../../../components/forms/CommonRadioOpcoes";
import { handleChangeCheck, handleChangeNameValue } from "../../../helpers/handleFormChanges";
import CommonCheckboxOpcao from "../../../components/forms/CommonCheckboxOpcao";

function EmailMassaModal({ emailMassaModalHook, valuesHook, emailMassa }) {
  const { emailEmMassaModal, setEmailEmMassaModal } = emailMassaModalHook;
  const { values, setValues } = valuesHook;

  return (
    <CommonModal
      title="Envio de e-mail em massa"
      is_open_modal={emailEmMassaModal}
      set_is_open_modal={setEmailEmMassaModal}
      size="lg"
      buttons={[
        <button
          key={`email-massa`}
          type="button"
          onClick={() => {
            emailMassa();
          }}
          className="btn btn-success"
        >
          Enviar
        </button>,
      ]}
    >
      <div className="row">
        <div className="col">
          <CommonRadioOpcoes
            label="Opção de envio"
            id="opcao_envio"
            upValue={values.opcao_envio}
            lowValue={!values.opcao_envio}
            upOnChange={(e) =>
              handleChangeNameValue(
                "opcao_envio",
                e.target.checked,
                values,
                setValues
              )
            }
            lowOnChange={(e) =>
              handleChangeNameValue(
                "opcao_envio",
                !e.target.checked,
                values,
                setValues
              )
            }
            upText="Somente notas selecionadas"
            lowText="Todas notas do período selecionado"
          />
        </div>
      </div>
      <div className="row pt-3">
        <div className="col">
          <label>Tipos de arquivo</label>
          <CommonCheckboxOpcao
            label="PDF"
            id="download_pdf"
            value={values.download_pdf}
            onChange={(e) => handleChangeCheck(e, values, setValues)}
            style={{ marginBottom: ".25rem" }}
          />
          <CommonCheckboxOpcao
            label="XML"
            id="download_xml"
            value={values.download_xml}
            onChange={(e) => handleChangeCheck(e, values, setValues)}
          />
        </div>
      </div>
    </CommonModal>
  );
}

EmailMassaModal.propTypes = {
  emailMassaModalHook: PropTypes.shape({
    emailEmMassaModal: PropTypes.bool.isRequired,
    setEmailEmMassaModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  emailMassa: PropTypes.func.isRequired,
};

export default EmailMassaModal;
